import { c as _c } from "react/compiler-runtime";
import { Icon, TextLink, TextPassage } from '@petsmart-ui/sparky';
import './EarnedPoints.scss';
interface EarnedPointsProps {
  points: number;
}
export function EarnedPoints(t0) {
  const $ = _c(6);
  const {
    points
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon size="md" name="treats-icon" className="sparky-u-margin-right-sm" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== points) {
    t2 = <TextPassage>{points} points earned</TextPassage>;
    $[1] = points;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TextLink className="view-points-link">View points</TextLink>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="earned-points" data-testid="earned-points">{t1}{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}